import { Button, Drawer, message } from "antd";
import Input from "../../Components/CommonCommponents/Input";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Womanwithlaptop from "../../Assets/Icons/GroupLaptop.png";
import AuthService from "../../Service.js/authService";
import { useState } from "react";
import { Alert } from "antd";
import toast from "react-hot-toast";
import Login from "./Login";
import ForgetPassword from "./ForgetPassword";

const CandidateLogin = (props) => {
  const location = useLocation();
  console.log("location", location.pathname.includes("jobDetails"));
  const navigate = useNavigate();
  const [messageApi, messageContextHolder] = message.useMessage();
  const [isprogress, setProgress] = useState(false);
  const [isFormError, setFormError] = useState(false);
  const [strFormType, setFormType] = useState();
  const [strMessage, setMessage] = useState();
  const [page, setPage] = useState("login");
  const {
    register,
    control,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleClick = () => {
    props.onClose();
  };
  // const onSubmit = async (data) => {
  //   data["is_candidate_login"] = true;
  //   data["company_domain"] = "http://ndz.yvi.com/";
  //   await AuthService.candidateLogin(data)
  //     .then(
  //       (oResponse) => {
  //         console.log("oResponse", oResponse);
  //         localStorage.setItem(
  //           "candidate",
  //           JSON.stringify(oResponse.data.data)
  //         );
  //         if (location.pathname.includes("jobDetails")) {
  //           props.onClose();
  //         } else {
  //           navigate("/");
  //           window.location.reload();
  //           setProgress(false);
  //         }

  //         // requestPermission();
  //         toast.success("Login successfully!");
  //       },
  //       (error) => {
  //         console.log("loginError", error);
  //         const errorMessage = error.response.data.error_info.detail;
  //         console.log(errorMessage);
  //         setFormError(true);
  //         setFormType("error");
  //         setMessage(errorMessage);
  //         setProgress(false);
  //       }
  //     )
  //     .catch((err) => {
  //       console.log(err);
  //       setProgress(false);
  //     });
  // };

  return (
    <div>
      <Drawer
        title={null}
        width={660}
        placement="right"
        onClose={props.onClose}
        open={props.open}
        style={{
          borderRadius: "50px 0 0 50px",
          // Other styles
        }}
        closeIcon={<div className="custom-close-icon">&times;</div>}
        className="login"
      >
        <div className="mx-20 mt-4">
          {page === "forgot_password" ? (
            <p className="text-3xl font-semibold">Reset Password</p>
          ) : (
            <p className="text-3xl font-semibold">Login</p>
          )}
          {page !== "forgot_password" && (
            <p className="text-gray-600 font-poppins text-base font-normal mt-2">
              Hello! let's get started
            </p>
          )}

          <div>
            {page === "forgot_password" ? (
              <ForgetPassword />
            ) : (
              <Login
                handleClick={handleClick}
                onClose={props?.onClose}
                setPage={setPage}
              />
            )}
            {/* <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mt-10">
                <div className="w-full">
                  <Input
                    name="username"
                    label=""
                    control={control}
                    placeholder="Username or Email or phonenumber "
                    rules={{
                      required: "This field is required",
                    }}
                    className="h-12"
                  />
                </div>
                <div className="w-full ">
                  <Input
                    type="password"
                    name="password"
                    label=""
                    placeholder="Enter password"
                    control={control}
                    rules={{
                      required: "This field is required",
                    }}
                    className="h-12"
                  />
                </div>
              </div>
              <div className="mt-10">
                <button
                  className="bg-[#FF4544] text-white w-full rounded-md h-[42px]"
                  type="submit"
                >
                  LOGIN
                </button>
              </div>
              <span className="flex text-base font-medium mt-6 mb-12 items-center justify-end ">
                <Link
                  to="/forgetPassword"
                  className="text-xl text-red-500"
                  onClick={handleClick}
                >
                  Forgot password ?
                </Link>
              </span>
              <div className="h-1 bg-[#EAEAEA] mb-14"></div>
            </form> */}
          </div>
        </div>
        <div className="h-1 bg-[#EAEAEA] mb-14 mx-20"></div>
        <div>
          <div className="flex items-center justify-center">
            <p className="text-xl">Don't have an account?</p>
            <Link
              to="/signup/"
              className="text-xl text-red-500"
              onClick={handleClick}
            >
              Sign Up
            </Link>
          </div>
          <div className="w-full">
            <img src={Womanwithlaptop} alt="gdweh" className="" />
          </div>
        </div>
      </Drawer>
    </div>
  );
};
export default CandidateLogin;
